import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import _range from 'lodash/range';

import EmptyStarIcon from '@ott/icon-small-star-empty';
import FilledStarIcon from '@ott/icon-small-star-filled';
import HalfFilledStarIcon from '@ott/icon-small-star-half-filled';

import styles from './StarRating.scss';

function StarRating(props) {
  const { className, total, color, rating, showEmpty, isWideIndent, isSmallStars } = props;

  const roundedRating = Math.ceil(rating);
  const actualTotal = (showEmpty ? total : roundedRating) + 1;

  const renderStar = index => {
    const isHalfStar = index - rating < 1 && index - rating > 0;
    if (isHalfStar) {
      return (
        <HalfFilledStarIcon
          key={index}
          className={cls(styles.star, styles[`${color}Star`])}
          emptyHalfClassName={styles.emptyStar}
        />
      );
    }

    const isEmptyStar = index > rating;
    if (isEmptyStar) {
      return <EmptyStarIcon key={index} className={cls(styles.star, styles.emptyStar)} />;
    }

    return <FilledStarIcon key={index} className={cls(styles.star, styles[`${color}Star`])} />;
  };

  return (
    <div
      className={cls(
        styles.StarRating,
        isWideIndent && styles.wideIndentStars,
        isSmallStars && styles.smallStars,
        className
      )}
    >
      {_range(1, actualTotal).map(renderStar)}
    </div>
  );
}

StarRating.propTypes = {
  className: PropTypes.string,
  rating: PropTypes.number.isRequired,
  total: PropTypes.number,
  color: PropTypes.oneOf(['black', 'yellow']),
  showEmpty: PropTypes.bool,
  isSmallStars: PropTypes.bool,
  isWideIndent: PropTypes.bool,
};

StarRating.defaultProps = {
  className: undefined,
  total: 5,
  color: 'black',
  showEmpty: false,
  isSmallStars: false,
  isWideIndent: false,
};

export default StarRating;
